export enum EStayPermissions{
    SHARED_HOST_SHOW = "shared.host.show",
    SHARED_STAY_QUOTE_WITH_FEES_VIEW = "shared.stay.quoteWithFees.view",
    SHARED_STAY_QUOTE_WITH_FEES_CHOOSE = "shared.stay.quoteWithFees.choose",
}
